import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonCommonModule } from '../../common/components/common.module';
import { ImageComponent } from './image/image.component';

@NgModule({
  declarations: [ImageComponent],
  imports: [CommonModule, SkeletonCommonModule],
  exports: [ImageComponent]
})
export class ImageModule {}
